import React, { useState, useEffect, useRef } from "react";
import {
  Link,
  useParams,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Table,
  Tooltip,
} from "antd";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import {
  getRequest,
  getRequest1,
  patchRequest,
  postRequest,
} from "../../axios";
import { authUserData } from "../../utils/Helper";
import { FilterFilled } from "@ant-design/icons";
import { ReactComponent as RupeesSign } from "../../image/RupeesSign.svg";
import ButtonField from "../../common/htmlComponents/ButtonField";
import ApprovalForPO from "../../authentication/ApprovalForPO";
import ApprovalForRFQ from "../../authentication/ApprovalForRFQ";
import ExelDownload from "../../image/exeldownload.svg";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ComparativeSiteWise from "./ComparativeSiteWise";
import ShowComparatives from "./ShowComparatives";
import ShowComparativeDiameterWise from "./ShowComparativeDiameterWise";

const ApproveRFQ = () => {
  const { t } = useTranslation();
  const { Option } = Select;
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [reload, setReload] = useState(false);
  const [siteName, setSiteName] = useState([]);
  const [materialName, setMaterialName] = useState([]);
  const [enableInputs, setEnableInputs] = useState(false);
  const { id, token } = useParams();
  const navigate = useNavigate();
  const { Search } = Input;
  const [totalCount, settotalCount] = useState(0);
  const [rfqHistory, setRFQHistory] = useState([]);
  const [categoryTree, setCategoryTree] = useState([]);
  const [siteDetails, setSiteDetails] = useState(null);
  const [initialRender, setInitialRender] = useState(true);
  const formRef = useRef();
  const [floatId, setFloatId] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnLoading2, setBtnLoading2] = useState(false);

  const [searchParams] = useSearchParams();
  const poStatus = searchParams.get("po_status");
  const pdfContainerRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    hide_r0_price: false,
    hide_r1_price: false,
    hide_r_price: false,
    site_id: [],
    material_type_id: [],
  });

  const [hideInitialBidPrice, sethideInitialBidPrice] = useState(false);
  const [hideR1BidPrice, setHideR1BidPrice] = useState(false);
  const [hideRBidPrice, setHideRBidPrice] = useState(false);
  const [showUnitRateCementR1, setShowUnitRateCementR1] = useState(false);
  const [showUnitRateCementR, setShowUnitRateCementR] = useState(false);
  const [isFinalBidPrice, setIsFinalBidPrice] = useState(false);
  const [showAdditionalCheckboxesFinal, setShowAdditionalCheckboxesFinal] =
    useState(true);
  const [showAdditionalCheckboxes, setShowAdditionalCheckboxes] =
    useState(false);
  const [comparativesRFQ, setComparativesRFQ] = useState([]);
  const [rfqNumber, setRfqNumber] = useState(null);
  const [poTotalAmount, setPoTotalAmount] = useState(0);
  const [apiLoading, setapiloading] = useState(false);
  const [purchasePattern, setPurchasePattern] = useState(null);
  const [isDiameterWise, setIsDiameterWise] = useState(true);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const action = queryParams.get("po_status");

  useEffect(() => {
    const getVendorBidRFQ = async () => {
      try {
        setapiloading(true);

        if (action === "ApproveandIssueOrder") {
          setapiloading(true);
          await postRequest(
            "po-order/purchase-order-approval/" +
              token +
              "/" +
              `${id}` +
              `/?po_status=ApproveandIssueOrder`
          ).then((response) => {
            navigate("/request-for-quotation/purchase-order-summary");
            // SuccessNotificationMsg("PO Approved Successfully");
          });
        } else if (action === "ApproveandPrepareDraftOrder") {
          setapiloading(true);
          await postRequest(
            "po-order/purchase-order-approval/" +
              token +
              "/" +
              `${id}` +
              `/?po_status=ApproveandPrepareDraftOrder`
          ).then((response) => {
            navigate("/request-for-quotation/purchase-order-summary");
            SuccessNotificationMsg("PO Approved Successfully");
          });
        } else if (action === "RejectedWithReason") {
          setapiloading(true);
          const response = await getRequest(
            `po-order/${id}/preview-and-send-for-approval/`
          );
          if (response.data.data) {
            setRfqNumber(response.data.data.rfq_number);
            setPoTotalAmount(response?.data?.data?.total_amount);
            setFloatId(response.data.data.float_rfq);
            const responseData =
              response?.data?.data?.purchase_order_city_details;

            setPurchasePattern(response.data.data.purchase_order_pattern);
            if(response?.data?.data?.is_diameter_wise === true){
              setIsDiameterWise(true);
            } else {
              setIsDiameterWise(false);
            }

            let tableData = [];

            if(response.data.data) {
          tableData = responseData?.map((item, index) => {
            const citySubTotal = item.vendor_city_total.reduce(
              (acc, amount) => acc + amount.amount_with_gst,
              0
            );

            const citySubTotalWithoutGST = item.vendor_city_total.reduce(
              (acc, amount) => acc + amount.amount_without_gst,
              0
            );

            return {
              key: item.po_city_name,
              cityName: item.po_city_name,
              citySubTotal: citySubTotal,
              citySubTotalWithoutGST: citySubTotalWithoutGST,
              comparative: item.purchase_order_site_details.map((com, ind) => {
                const siteSubTotal =
                  com.vendor_site_sub_total[0].amount_without_gst;
                const siteSubTotalWithGST =
                  com.vendor_site_sub_total[0].amount_with_gst;

                return {
                  siteName: com.rfq_site_name,
                  siteId: com.rfq_site_id,
                  siteSubTotal: siteSubTotal,
                  siteSubTotalWithGST: siteSubTotalWithGST,
                  vendorWise: com.po_vendor_detail.map((it, index) => {
                    console.log("itoiy", it);

                    return {
                      vendorName: it.vendor_name,
                      rank: {
                        comparison_ranking: it.comparison_ranking,
                        selected_seasons: it.selected_seasons,
                        other_reason_text: it.other_reason_text,
                      },
                      siteLocations: it.po_material_detail.map(
                        (item1, index) => {
                          console.log("item1cc", item1);

                          return {
                            materialName: item1.bid_material_type_name,
                            quantity: item1.bid_material_quantity,
                            uom: item1.bid_uom,
                            r_unit_price: Number(item1.unit_rate),
                            r_total_price: item1.amount_without_gst,
                            total_amount_with_gst: item1.amount_with_gst,
                            diameter_details: item1.diameter_details,
                          };
                        }
                      ),
                    };
                  }),
                };
              }),
            };
          });
            } else {
     tableData = responseData?.map((item, index) => {
              const citySubTotal = item.vendor_city_total.reduce(
                (acc, amount) => acc + amount.amount_with_gst,
                0
              );
  
              const citySubTotalWithoutGST = item.vendor_city_total.reduce(
                (acc, amount) => acc + amount.amount_without_gst,
                0
              );
  
              return {
                key: item.po_city_name,
                cityName: item.po_city_name,
                citySubTotal: citySubTotal,
                citySubTotalWithoutGST: citySubTotalWithoutGST,
                comparative: item.purchase_order_site_details.map((com, ind) => {
                  const siteSubTotal =
                    com.vendor_site_sub_total[0].amount_without_gst;
                  const siteSubTotalWithGST =
                    com.vendor_site_sub_total[0].amount_with_gst;
  
                  return {
                    siteName: com.rfq_site_name,
                    siteId: com.rfq_site_id,
                    siteSubTotal: siteSubTotal,
                    siteSubTotalWithGST: siteSubTotalWithGST,
                    vendorWise: com.po_vendor_detail.map((it, index) => {
                      console.log("itoiy", it);
  
                      return {
                        vendorName: it.vendor_name,
                        rank: {
                          comparison_ranking: it.comparison_ranking,
                          selected_seasons: it.selected_seasons,
                          other_reason_text: it.other_reason_text
                        },
                        siteLocations: it.po_material_detail.map(
                          (item1, index) => {
                            return {
                              materialName: item1.bid_material_type_name,
                              quantity: item1.bid_material_quantity,
                              uom: item1.bid_uom,
                              r_unit_price: item1.unit_rate,
                              r_total_price: item1.amount_without_gst,
                              total_amount_with_gst: item1.amount_with_gst,
                            };
                          }
                        ),
                      };
                    }),
                  };
                }),
              };
            });
            }
         

            setComparativesRFQ(tableData);

            const poTotalAmount = responseData?.reduce((total, item) => {
              const cityTotal = item.vendor_city_total.reduce(
                (acc, vendor) => acc + vendor.amount_with_gst,
                0
              );
              return total + cityTotal;
            }, 0);

            setPoTotalAmount(poTotalAmount);

            setapiloading(false);
          } else {
            ErrorNotificationMsg(t("Error in Comparatives"));
            setapiloading(false);
          }
        } else {
          setapiloading(true);
          const response = await getRequest(
            `po-order/${id}/preview-and-send-for-approval/`
          );
          if (response.data.data) {
            setRfqNumber(response.data.data.rfq_number);
            // setBuyer(response.data.data.buyer_name);
            // setFirstApprover(response.data.data.first_approver_name);
            // setSecondApprover(response.data.data.second_approver_name);
            setPoTotalAmount(response?.data?.data?.total_amount);
            // setIsCompleted(response?.data?.data?.po_approval);
            // const responseData = response?.data?.data?.site_wise_data;
            const responseData =
              response?.data?.data?.purchase_order_city_details;
  
            // const tableData = response?.data?.data?.summery_of_price_comparative?.map((item, index) => {
  
            let tableData = responseData?.map((item, index) => {
              const citySubTotal = item.vendor_city_total.reduce(
                (acc, amount) => acc + amount.amount_with_gst,
                0
              );
  
              const citySubTotalWithoutGST = item.vendor_city_total.reduce(
                (acc, amount) => acc + amount.amount_without_gst,
                0
              );
  
              return {
                key: item.po_city_name,
                cityName: item.po_city_name,
                citySubTotal: citySubTotal,
                citySubTotalWithoutGST: citySubTotalWithoutGST,
                comparative: item.purchase_order_site_details.map((com, ind) => {
                  const siteSubTotal =
                    com.vendor_site_sub_total[0].amount_without_gst;
                  const siteSubTotalWithGST =
                    com.vendor_site_sub_total[0].amount_with_gst;
  
                  return {
                    siteName: com.rfq_site_name,
                    siteId: com.rfq_site_id,
                    siteSubTotal: siteSubTotal,
                    siteSubTotalWithGST: siteSubTotalWithGST,
                    vendorWise: com.po_vendor_detail.map((it, index) => {
                      console.log("itoiy", it);
  
                      return {
                        vendorName: it.vendor_name,
                        rank: {
                          comparison_ranking: it.comparison_ranking,
                          selected_seasons: it.selected_seasons,
                          other_reason_text: it.other_reason_text
                        },
                        siteLocations: it.po_material_detail.map(
                          (item1, index) => {
                            return {
                              materialName: item1.bid_material_type_name,
                              quantity: item1.bid_material_quantity,
                              uom: item1.bid_uom,
                              r_unit_price: item1.unit_rate,
                              r_total_price: item1.amount_without_gst,
                              total_amount_with_gst: item1.amount_with_gst,
                            };
                          }
                        ),
                      };
                    }),
                  };
                }),
              };
            });
            console.log('tableDatafd', tableData);
            
            setComparativesRFQ(tableData);
  
            const poTotalAmount = responseData?.reduce((total, item) => {
              const cityTotal = item.vendor_city_total.reduce(
                (acc, vendor) => acc + vendor.amount_with_gst,
                0
              );
              return total + cityTotal;
            }, 0);
  
            setPoTotalAmount(poTotalAmount);
  
            //       const sites = response.data.data.site_wise_data.map(item => ({
            //         id: item.site_id,
            //         name: item.site_name
            //       }));
            //       setSiteName(sites);
  
            //       const materialTypes = response.data.data.site_wise_data.flatMap(item =>
            //         item.material_wise_data.map(material => ({
            //           id: material.rfq_material_type_id,
            //           name: material.material_name
            //         }))
            //       );
  
            //       const uniqueMaterialTypes = materialTypes.filter((material, index, self) =>
            //         index === self.findIndex(m => m.id === material.id && m.name === material.name)
            //       );
  
            //       setMaterialName(uniqueMaterialTypes);
  
            setapiloading(false);
          } else {
            ErrorNotificationMsg(t("Error in Comparatives"));
            setapiloading(false);
          }
        }
      } catch (error) {
        console.error("Error:", error);
        setapiloading(false);
      }
    };
    getVendorBidRFQ();
  }, [id]);

  const handleSubmit = async () => {
    try {
      let response;
      if (action === "ApproveandIssueOrder") {
        await postRequest(
          "po-order/purchase-order-approval/" +
            token +
            "/" +
            `${id}` +
            `/?po_status=ApproveandIssueOrder`
        ).then((response) => {
          SuccessNotificationMsg("PO Approved Successfully");
        });
        navigate("/request-for-quotation/purchase-order-summary");
      } else if (action === "RejectedWithReason") {
        await postRequest(
          "po-order/purchase-order-approval/" +
            token +
            "/" +
            `${id}` +
            `/?po_status=RejectedWithReason`
        ).then((response) => {
          navigate("/request-for-quotation/history");
          ErrorNotificationMsg("PO Rejected Successfully");
        });
      }
    } catch (error) {
      console.log(error);
      ErrorNotificationMsg(error);
    }
  };

  const handleReject = async () => {
    setBtnLoading2(true);
    await postRequest(
      "po-order/purchase-order-approval/" +
        token +
        "/" +
        `${id}` +
        `/?po_status=RejectedWithReason`
    )
      .then((response) => {
        navigate("/request-for-quotation/history");
        // SuccessNotificationMsg(response?.data?.message);
        setBtnLoading2(false);
      })
      .catch((err) => {
        console.error(err.message ? err.message : "error");
        setBtnLoading2(false);
      });
  };
  const handleDirectRelease = async () => {
    setBtnLoading(true);
    await postRequest(
      "po-order/purchase-order-approval/" +
        token +
        "/" +
        `${id}` +
        `/?po_status=ApproveandIssueOrder`
    )
      .then((response) => {
        SuccessNotificationMsg(
          response.message ? response.message : "PO Approved Successfully"
        );
        navigate("/request-for-quotation/purchase-order-summary");
        setBtnLoading(false);
      })
      .catch((err) => {
        console.error(err.message ? err.message : "error");
        setBtnLoading(false);
      });
  };

  const handleApproveDraftOrder = async () => {
    setBtnLoading(true);
    await postRequest(
      "po-order/purchase-order-approval/" +
        token +
        "/" +
        `${id}` +
        `/?po_status=ApproveandPrepareDraftOrder`
    ).then((response) => {
      SuccessNotificationMsg(response?.data?.message);
      navigate("/request-for-quotation/purchase-order-summary");
      setBtnLoading(false);
    });
  };

  const handleCheckboxChange = () => {
    setIsFinalBidPrice(!isFinalBidPrice);
    setShowAdditionalCheckboxesFinal(true);

    setState((prevState) => ({
      ...prevState,
      is_final_bid_price: !isFinalBidPrice,
    }));
  };

  const handleCheckboxhideR1 = () => {
    sethideInitialBidPrice(!hideInitialBidPrice);
  };

  const handleCheckboxhideR = () => {
    setHideR1BidPrice(!hideR1BidPrice);
  };

  const handleCheckboxhideRR = () => {
    setHideRBidPrice(!hideRBidPrice);
  };

  const updateState = async () => {
    console.log("state ", state);
  };

  const handleSiteNameSelectChange = async (value) => {
    const updatedState1 = { ...state, site_id: value };
    setState(updatedState1);
  };
  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
    } else {
      updateState();
    }
  }, [state]);

  const handleMaterialSelectChange = async (value) => {
    const updatedState2 = { ...state, material_type_id: value };
    setState(updatedState2);
  };

    function sumAmounts(rows, field) {
    return rows.reduce((sum, row) => sum + (row[field] || 0), 0);
  }

  function makeSiteTotalRow(rows, siteName) {
    const totalWithoutGST = sumAmounts(rows, '_amount_without_gst');
    const totalWithGST = sumAmounts(rows, '_amount_with_gst');
    return {
      key: `site-subtotal-${siteName}-${Math.random()}`,
      "Sr.No": '',
      City: '',
      "Site Name": 'Sub Total',
      "Vendor Name": '',
      rank: '',
      Items: '',
      Diameter: '',
      Quantity: '',
      UOM: '',
      "Unit Rate": '',
      "Total Amount": `\u20B9 ${totalWithoutGST.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`,
      TotalAmountGST: `\u20B9 ${totalWithGST.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`,
    };
  }

  function makeCityTotalRow(rows, cityName) {
    const totalWithoutGST = sumAmounts(rows, '_amount_without_gst');
    const totalWithGST = sumAmounts(rows, '_amount_with_gst');
    return {
      key: `city-subtotal-${cityName}-${Math.random()}`,
      "Sr.No": '',
      City: '',
      "Site Name": 'City Sub Total',
      "Vendor Name": '',
      rank: '',
      Items: '',
      Diameter: '',
      Quantity: '',
      UOM: '',
      "Unit Rate": '',
      "Total Amount": `\u20B9 ${totalWithoutGST.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`,
      TotalAmountGST: `\u20B9 ${totalWithGST.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`,
    };
  }
  let data = [];

  if(isDiameterWise){
  let data1 = comparativesRFQ?.flatMap((city, cityIndex) =>
    city.comparative.flatMap((site, siteIndex) =>
      site.vendorWise.flatMap((vendor, vendorIndex) =>
        vendor.siteLocations.flatMap((material, materialIndex) =>
          (material.diameter_details || []).map((diameter, diameterIndex) => ({
            key: `${cityIndex}-${siteIndex}-${vendorIndex}-${materialIndex}-${diameterIndex}`,
            "Sr.No": cityIndex + 1,
            City: city.cityName,
            "Site Name": site.siteName,
            "Vendor Name": vendor.vendorName,
            rank: vendor.rank,
            Items: material.materialName,
            Diameter: diameter.diameter_value,
            Quantity: diameter.diameter_quantity,
            UOM: material.uom,
            "Unit Rate": `\u20B9 ${Number(
              (diameter.unit_rate || "0").replace(/,/g, "")
            )?.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`,
            "Total Amount": `\u20B9 ${Number(
              diameter.amount_without_gst
            )?.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`,
            TotalAmountGST: `\u20B9 ${Number(
              diameter.amount_with_gst
            )?.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`,
            // For subtotal/city total calculations
            _amount_without_gst: Number(diameter.amount_without_gst),
            _amount_with_gst: Number(diameter.amount_with_gst),
          }))
        )
      )
    )
  );

  // Insert Sub Total and City Sub Total rows
  let processedDataWithTotals = [];
  let currentCity = null;
  let currentSite = null;
  let siteRows = [];
  let cityRows = [];



  data1.forEach((row, idx) => {
    // New city
    if (row.City !== currentCity) {
      // If not first city, push city total
      if (cityRows.length > 0) {
        processedDataWithTotals.push(makeCityTotalRow(cityRows, currentCity));
        cityRows = [];
      }
      currentCity = row.City;
      currentSite = null;
    }
    // New site
    if (row["Site Name"] !== currentSite) {
      // If not first site, push site total
      if (siteRows.length > 0) {
        processedDataWithTotals.push(makeSiteTotalRow(siteRows, currentSite));
        siteRows = [];
      }
      currentSite = row["Site Name"];
    }
    processedDataWithTotals.push(row);
    siteRows.push(row);
    cityRows.push(row);

    // If last row, push both totals
    if (idx === data.length - 1) {
      if (siteRows.length > 0) processedDataWithTotals.push(makeSiteTotalRow(siteRows, currentSite));
      if (cityRows.length > 0) processedDataWithTotals.push(makeCityTotalRow(cityRows, currentCity));
    }
  });

  // Post-process data for display rules
  let lastCity = null;
  let lastSite = null;
  let lastMaterial = null;
  let srNo = 1;

  const processedData = processedDataWithTotals.map((row) => {
    if (row["Site Name"] === "Sub Total" || row["Site Name"] === "City Sub Total") {
      return row;
    }
    let showCity = false;
    let showVendorAndRank = false;
    let showSite = false;
    let showMaterial = false;

    if (row.City !== lastCity) {
      showCity = true;
      showVendorAndRank = true;
      showSite = true;
      showMaterial = true;
      lastCity = row.City;
      lastSite = row["Site Name"];
      lastMaterial = row.Items;
    } else if (row["Site Name"] !== lastSite) {
      showVendorAndRank = true;
      showSite = true;
      showMaterial = true;
      lastSite = row["Site Name"];
      lastMaterial = row.Items;
    } else if (row.Items !== lastMaterial) {
      showMaterial = true;
      lastMaterial = row.Items;
    }

    return {
      ...row,
      "Sr.No": showCity ? srNo++ : "",
      City: showCity ? row.City : "",
      "Site Name": showSite ? row["Site Name"] : "",
      Items: showMaterial ? row.Items : "",
      "Vendor Name": showVendorAndRank ? row["Vendor Name"] : "",
      rank: showVendorAndRank ? row.rank : "",
    };
  });

  data = processedData
  } else {
    data = comparativesRFQ?.flatMap((item, index) => {
      const citySubTotal = item.citySubTotal || 0;
      return item.comparative.flatMap((comparative, compIndex) => {
        console.log("comparativecomparative", comparative);
        const siteSubTotal = comparative.siteSubTotal || 0;
        const siteSubTotalWithGst =
          comparative.siteSubTotalWithGST?.toLocaleString("en-IN", {
            maximumFractionDigits: 0,
          }) || 0;
  
        return comparative.vendorWise.flatMap((vendor, vendorIndex) => {
          console.log("vendoreee8", vendor);
  
          return vendor.siteLocations.flatMap((location, locationIndex) => {
            console.log('locationcx', location);
            
            return [
              {
                key: `${index}-${compIndex}-${vendorIndex}-${locationIndex}`,
                "Sr.No":
                  locationIndex === 0 && compIndex === 0 ? `${index + 1}` : null,
                City:
                  locationIndex === 0 && compIndex === 0
                    ? `${item.cityName}`
                    : null,
                "Site Name":
                  locationIndex === 0 ? `${comparative.siteName}` : null,
                "Vendor Name":
                  locationIndex === 0 ? vendor.vendorName || "" : null,
                rank: locationIndex === 0 ? vendor.rank : null,
                other_reason_text: locationIndex === 0 ? vendor.other_reason_text : null,
                Items: `${location.materialName || ""}`,
                Quantity: `${location.quantity || ""}`,
                UOM: `${location.uom || ""}`,
                "Unit Rate": `${`\u20B9 ${
                  location.r_unit_price?.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  }) || 0
                }`}`,
                "Total Amount": `${`\u20B9 ${
                  location.r_total_price?.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  }) || 0
                }`}`,
                TotalAmountGST: `${`\u20B9 ${
                  location?.total_amount_with_gst?.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  }) || 0
                }`}`,
              },
              locationIndex === vendor.siteLocations.length - 1 && {
                key: `${index}-${compIndex}-${vendorIndex}-SubTotal`,
                "Site Name": <span className="subtotal1">Sub Total</span>,
                // 'Total Amount':<Input disabled value={`\u20B9 ${siteSubTotal.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`} />,
                "Total Amount": (
                  <div className="subtotal1">
                    ₹{" "}
                    {siteSubTotal?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}
                  </div>
                ),
  
                // 'TotalAmountGST': <Input disabled value={`\u20B9 ${siteSubTotalWithGst.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`} className='subtotal' />,
  
                TotalAmountGST: (
                  <div className="subtotal1">
                    {" "}
                    ₹{" "}
                    {siteSubTotalWithGst.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}{" "}
                  </div>
                ),
              },
  
              locationIndex === vendor.siteLocations.length - 1 &&
                compIndex === item.comparative.length - 1 && {
                  key: `${index}-CitySubTotal`,
                  "Site Name": <span className="citytotal2">City Sub Total</span>,
                  // 'Total Amount': <Input disabled value={`\u20B9 ${item.citySubTotalWithoutGST.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`} />,
  
                  "Total Amount": (
                    <div className="citytotal2">
                      ₹{" "}
                      {item.citySubTotalWithoutGST.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}{" "}
                    </div>
                  ),
  
                  TotalAmountGST: (
                    <div className="citytotal2">
                      ₹{" "}
                      {citySubTotal.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}
                    </div>
                  ),
                },
            ].filter(Boolean);
          });
        });
      });
    });

  }


  const handleUnitRateOfCementChangeR0 = (
    value,
    recordKey,
    siteIndex,
    gstRate,
    quantity
  ) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r_price[0].r_unit_price = value;
    site.vendorBids[0].r_price[0].r_total_price =
      ((value * (100 + gstRate)) / 100) * quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const handleUnitRateOfFreightChangeR0 = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r_price[0].r_unit_price = value;
    site.vendorBids[0].r_price[0].r_total_price = value * site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const handleTotalUnitRateR0Change = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r_price[0].r_total_price = value;
    site.vendorBids[0].r_price[0].r_unit_price = value / site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };
  const [enableInputsR1, setEnableInputsR1] = useState(false);

  const handleUnitRateOfCementChangeR1 = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r1_price[0].r1_unit_price = value;
    site.vendorBids[0].r1_price[0].r1_total_price = value * site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const calculateTotalUnitRateOfCementR1 = (record) => {
    const totalUnitRateOfCementR1 = record.siteLocations.reduce(
      (total, site) =>
        total + (parseFloat(site.vendorBids[0].r1_price[0].r1_unit_price) || 0),
      0
    );
    return totalUnitRateOfCementR1.toFixed(2);
  };

  const handleUnitRateOfFreightChangeR1 = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r1_price[0].r1_unit_price = value;
    site.vendorBids[0].r1_price[0].r1_total_price = value * site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const handleTotalUnitRateOfCementR1Change = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r1_price[0].r1_total_price = value;
    site.vendorBids[0].r1_price[0].r1_unit_price = value / site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };
  const renderUnitRateOfCementR0 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              disabled={enableInputs}
              style={{ marginRight: "10px", width: "300px" }}
              value={site.vendorBids[0].r_price[0].r_unit_price}
              onChange={(e) =>
                handleUnitRateOfCementChangeR0(
                  e.target.value,
                  record.key,
                  siteIndex,
                  site.vendorBids[0].gst_rate,
                  site.quantity
                )
              }
              type="number"
            />
          ))}
        </div>
      </>
    );
  };

  const calculateTotalUnitRateOfCementR0 = (record) => {
    const totalUnitRateOfCement = record.siteLocations.reduce(
      (total, site) =>
        total + (parseFloat(site.vendorBids[0].r_price[0].r_unit_price) || 0),
      0
    );
    return totalUnitRateOfCement.toFixed(2);
  };

  const calculateTotalUnitRateOfFreightR0 = (record) => {
    const totalUnitRateOfFreightR0 = record.siteLocations.reduce(
      (total, site) =>
        total + (parseFloat(site.vendorBids[0].r_price[0].r_unit_price) || 0),
      0
    );
    return totalUnitRateOfFreightR0.toFixed(2);
  };

  const renderUnitRateOfFreightR1 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              prefix={<RupeesSign />}
              disabled={enableInputsR1}
              style={{ marginRight: "10px", width: "300px" }}
              placeholder={`Enter Unit Rate of Freight for ${site.name}`}
              value={site.vendorBids[0].r1_price[0].r1_unit_price}
              onChange={(e) =>
                handleUnitRateOfFreightChangeR1(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
        </div>

        <Input
          placeholder={`Total Unit Rate of Freight R1`}
          prefix={<RupeesSign />}
          value={calculateTotalUnitRateOfFreightR1(record)}
          style={{ width: "300px", top: "10px" }}
          disabled
        />
      </>
    );
  };

  const calculateTotalUnitRateOfFreightR1 = (record) => {
    const totalUnitRateOfFreightR1 = record.siteLocations.reduce(
      (total, site) =>
        total + (parseFloat(site.vendorBids[0].r1_price[0].r1_unit_price) || 0),
      0
    );
    return totalUnitRateOfFreightR1.toFixed(2);
  };

  const renderUnitRateOfTotalUnitRateR1 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              prefix={<RupeesSign />}
              disabled={enableInputsR1}
              style={{ marginRight: "10px", width: "300px" }}
              placeholder={`Enter Total Unit Rate for ${site.name}`}
              value={site.vendorBids[0].r1_price[0].r1_total_price}
              onChange={(e) =>
                handleTotalUnitRateOfCementR1Change(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
        </div>

        <Input
          placeholder={`Total Unit Rate of R1`}
          prefix={<RupeesSign />}
          value={calculateTotalUnitRateOfR1(record)}
          style={{ width: "300px", top: "10px" }}
          disabled
        />
      </>
    );
  };

  const calculateTotalUnitRateOfR1 = (record) => {
    const totalUnitRateOfCementR1 =
      parseFloat(calculateTotalUnitRateOfCementR1(record)) || 0;
    const totalUnitRateOfFreightR1 =
      parseFloat(calculateTotalUnitRateOfFreightR1(record)) || 0;

    return (totalUnitRateOfCementR1 + totalUnitRateOfFreightR1).toFixed(2);
  };

  const handleExcelDownload = async () => {
    const endpoint = `po-order/${id}/po-order-excel-download/`;
    const fileType = "csv";

    try {
      //setBtnloading(true);
      await getRequest(endpoint)
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "text/csv",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          //link.download = `purchase_requisition_${id}-${+new Date()}.${fileType}`;
          link.download = `float-rfq_${+new Date()}.${fileType}`;
          link.click();
          //setBtnloading(false);
        })
        .catch((error) => {
          //ErrorNotificationMsg(t(`err_${fileType}_download`));
        });
    } catch (error) {
      //setBtnloading(false);
      //ErrorNotificationMsg(error);
    }
  };

  const downloadAsPDF = async () => {
    try {
      // Capture the specified area as a canvas
      const canvas = await html2canvas(pdfContainerRef.current, { scale: 2 });

      // Get image data from the canvas
      const imgData = canvas.toDataURL("image/png");

      // Initialize jsPDF and set page size
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Set headline with centered alignment
      const headline = "Purchase Order";
      pdf.setFontSize(18);
      const textWidth = pdf.getTextWidth(headline);
      const centerX = (pageWidth - textWidth) / 2; // Center horizontally
      pdf.text(headline, centerX, 20);

      // Calculate image dimensions for PDF
      const imgWidth = 190; // Adjust width to fit within A4 dimensions
      const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

      let y = 30; // Initial vertical position for image

      // Check if image height exceeds page height and add pages if needed
      if (imgHeight > pageHeight - 40) {
        let remainingHeight = imgHeight;

        // Loop to add the image in chunks across multiple pages
        while (remainingHeight > 0) {
          pdf.addImage(
            imgData,
            "PNG",
            10,
            y,
            imgWidth,
            Math.min(remainingHeight, pageHeight - 40)
          );
          remainingHeight -= pageHeight - 40;

          if (remainingHeight > 0) {
            pdf.addPage();
            y = 10; // Reset top margin for new page
          }
        }
      } else {
        // If content fits on a single page
        pdf.addImage(imgData, "PNG", 10, 30, imgWidth, imgHeight);
      }

      // Save the PDF with a filename
      pdf.save(`Purchase-order_${+new Date()}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };
  let columns = [];


  if(isDiameterWise){
 columns = [
     {
       title: "Sr.",
       dataIndex: "Sr.No",
       width: "30px",
     },
     {
       title: "City",
       dataIndex: "City",
       width: "40px",
     },
     {
       title: "Site",
       dataIndex: "Site Name",
       width: "30px",
       render: (text, record) => {
         console.log('recorddd', record);
         
         if (record["Site Name"] === "Sub Total") {
           return <span className="subtotal">Sub Total</span>;
         } else if (record["Site Name"] === "City Sub Total") {
           return <span className="citytotal">City Total</span>;
         } else {
           return <span>{text}</span>;
         }
       },
     },
     {
       title: "Vendor",
       dataIndex: "Vendor Name",
       width: 120,
     },
     {
       title: "Rank",
       dataIndex: "rank",
       width: 120,
       align: "center",
       render: (text, record) => {
         console.log("texttext", text, "record", record);
 
         if (text?.comparison_ranking === "L1") {
           return (
             <>
               <Tooltip
                 color={"#094E8F"}
                 placement="left"
                 title={<span style={{ color: "#fff" }}>Lowest Price</span>}
               >
                 <p className="lowestven">{text?.comparison_ranking}</p>
               </Tooltip>
               <p style={{ color: "#094E8F", marginTop: "10px" }}>
                 {text?.other_reason_text &&
                   text?.other_reason_text !== "N/A" &&
                   text?.selected_seasons}
               </p>
             </>
           );
         } else if (text?.comparison_ranking === "L2") {
           return (
             <>
               <Tooltip
                 color={"#094E8F"}
                 placement="left"
                 title={
                   <span style={{ color: "#fff" }}>Second Lowest Price</span>
                 }
               >
                 <p className="secondLowestven">{text?.comparison_ranking}</p>
               </Tooltip>
               <p style={{ color: "#094E8F", marginTop: "10px" }}>
                 {text?.selected_seasons}
               </p>
               <p>
                 {text?.other_reason_text &&
                   text?.other_reason_text !== "N/A" &&
                   text?.other_reason_text}
               </p>
             </>
           );
         } else if (text?.comparison_ranking === "L3") {
           return (
             <>
               <Tooltip
                 color={"#094E8F"}
                 placement="left"
                 title={
                   <span style={{ color: "#fff" }}>Third Lowest Price</span>
                 }
               >
                 <p className="thirdLowestven">{text?.comparison_ranking}</p>
               </Tooltip>
               <p style={{ color: "#094E8F", marginTop: "10px" }}>
                 {text?.selected_seasons}
               </p>
               <p>{text?.other_reason_text && text?.other_reason_text}</p>
             </>
           );
         } else {
           return (
             <>
               <p>{text?.comparison_ranking}</p>
               <p>{text?.selected_seasons}</p>
               <p>{text?.other_reason_text && text?.other_reason_text}</p>
             </>
           );
         }
       },
     },
     {
       title: "Items",
       dataIndex: "Items",
       width: "80px",
     },
     {
       title: "Diameter",
       dataIndex: "Diameter",
       width: "60px",
       align: "center",
     },
     {
       title: "Qty.",
       dataIndex: "Quantity",
       width: "40px",
       align: "center",
     },
     {
       title: "UoM.",
       dataIndex: "UOM",
       width: "40px",
       align: "center",
       render: (text, record) => {
         if (text === "Cubic Meter") {
           return "Cu. Mtr.";
         } else {
           return text;
         }
       },
     },
     {
       title: "Unit Rate",
       dataIndex: "Unit Rate",
       width: "130px",
       align: "right",
     },
     {
       title: (
         <>
           <span>Total Amount</span>
           <br />
           <span>Without GST</span>
         </>
       ),
       dataIndex: "Total Amount",
       width: "100px",
       align: "right",
       render: (text, record) => {
         if (record["Site Name"] === "Sub Total") {
           return <div className="subtotall">{record["Total Amount"]}</div>;
         } else if (record["Site Name"] === "City Sub Total") {
           return <div className="citytotall">{record["Total Amount"]}</div>;
         } else {
           return <div style={{ marginRight: "10px" }}>{record["Total Amount"]}</div>;
         }
       },
     },
     {
       title: (
         <>
           <span>Total Amount</span>
           <br />
           <span>With GST</span>
         </>
       ),
       dataIndex: "TotalAmountGST",
       width: "100px",
       align: "right",
       render: (text, record) => {
         if (record["Site Name"] === "Sub Total") {
           return <div className="subtotall">{record["TotalAmountGST"]}</div>;
         } else if (record["Site Name"] === "City Sub Total") {
           return <div className="citytotall">{record["TotalAmountGST"]}</div>;
         } else {
           return <div style={{ marginRight: "10px" }}>{record["TotalAmountGST"]}</div>;
         }
       },
     },
   ];
  } else {
 columns = [
    {
      title: "Sr.",
      dataIndex: "Sr.No",
      width: "30px",
    },
    {
      title: "City",
      dataIndex: "City",
      width: "40px",
    },
    {
      title: "Site",
      dataIndex: "Site Name",
      width: "30px",
    },
    {
      title: "Vendor",
      dataIndex: "Vendor Name",
      width: 120,
    },
    {
      title: "Rank",
      dataIndex: "rank",
      width: 120,
      align: "center",
      render: (text, record) => {
        console.log("texttext", text, "record", record);

        if (text?.comparison_ranking === "L1") {
          return (
            <>
              <Tooltip
                color={"#094E8F"}
                placement="left"
                title={<span style={{ color: "#fff" }}>Lowest Price</span>}
              >
                <p className="lowestven">{text?.comparison_ranking}</p>
              </Tooltip>
              <p style={{ color: "#094E8F", marginTop: "10px" }}>
                {text?.other_reason_text && text?.other_reason_text !== 'N/A' && text?.selected_seasons}
              </p>
            </>
          );
        } else if (text?.comparison_ranking === "L2") {
          return (
            <>
              <Tooltip
                color={"#094E8F"}
                placement="left"
                title={
                  <span style={{ color: "#fff" }}>Second Lowest Price</span>
                }
              >
                <p className="secondLowestven">{text?.comparison_ranking}</p>
              </Tooltip>
              <p style={{ color: "#094E8F", marginTop: "10px" }}>
                {text?.selected_seasons}
              </p>
              <p>
                {
                  text?.other_reason_text && text?.other_reason_text !== 'N/A' && text?.other_reason_text
                }
              </p>
            </>
          );
        } else if (text?.comparison_ranking === "L3") {
          return (
            <>
              <Tooltip
                color={"#094E8F"}
                placement="left"
                title={
                  <span style={{ color: "#fff" }}>Third Lowest Price</span>
                }
              >
                <p className="thirdLowestven">{text?.comparison_ranking}</p>
              </Tooltip>
              <p style={{ color: "#094E8F", marginTop: "10px" }}>
                {text?.selected_seasons}
              </p>
              <p>
                {
                  text?.other_reason_text && text?.other_reason_text
                }
              </p>
            </>
          );
        } else {
          return (
            <>
              <p>{text?.comparison_ranking}</p>
              <p>{text?.selected_seasons}</p>
              <p>
                {
                  text?.other_reason_text && text?.other_reason_text
                }
              </p>
            </>
          );
        }
      },
    },
    {
      title: "Items",
      dataIndex: "Items",
      width: "80px",
    },
    {
      title: "Qty.",
      dataIndex: "Quantity",
      width: "40px",
      align: "center",
    },
    {
      title: "UoM.",
      dataIndex: "UOM",
      width: "40px",
      align: "center",
      render: (text, record) => {
        if (text === "Cubic Meter") {
          return "Cu. Mtr.";
        } else {
          return text;
        }
      },
    },
    {
      title: "Unit Rate",
      dataIndex: "Unit Rate",
      width: "130px",
      align: "right",
    },
    {
      title: (
        <>
          <span>Total Amount</span><br/>
          <span>Without GST</span>
        </>
          ),
      dataIndex: "Total Amount",
      width: "100px",
      align: "right",
      render: (text, record) => {
        if (record["Site Name"] === "Sub Total") {
          return (
            <div style={{ marginRight: "0px" }}>{record["Total Amount"]}</div>
          );
        } else if (record["Site Name"] === "City Sub Total") {
          return (
            <div style={{ marginRight: "0px" }}>{record["Total Amount"]}</div>
          );
        } else {
          return (
            <div style={{ marginRight: "10px" }}>{record["Total Amount"]}</div>
          );
        }
      },
    },
    {
      title: (
        <>
          <span>Total Amount</span><br/>
          <span>With GST</span>
        </>
          ),
      dataIndex: "TotalAmountGST",
      width: "100px",
      align: "right",
      render: (text, record) => {
        if (record["Site Name"] === "Sub Total") {
          return (
            <div style={{ marginRight: "0px" }}>{record["TotalAmountGST"]}</div>
          );
        } else if (record["Site Name"] === "City Sub Total") {
          return (
            <div style={{ marginRight: "0px" }}>{record["TotalAmountGST"]}</div>
          );
        } else {
          return (
            <div style={{ marginRight: "10px" }}>
              {record["TotalAmountGST"]}
            </div>
          );
        }
      },
    },
  ];
  }

  

  if (action === "ApproveandIssueOrder") {
    return (
      <section
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin spinning={apiLoading} />
      </section>
    );
  } else {
    if(isDiameterWise) {

    return (
      <>
        <Spin spinning={apiLoading}>
          <div className="ListingTopBar">
            <div className="pagenamewrap">
              <div className="pagename">
                <h3>Approve Purchase Order</h3>

                <Breadcrumb className="Breadcrumb-Sec">
                  <Breadcrumb.Item>Approval</Breadcrumb.Item>
                  <Breadcrumb.Item>Approve Purchase Order</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <div className="rgq-num-wrap">
                <h5 className="rfq-number new" >
                  RFQ Number : <span>{rfqNumber}</span>
                </h5>
              </div>
            </div>
          </div>

          <ShowComparativeDiameterWise />
          <section className="grid-sec mt-5">
            <div className="PR-body">
              <Spin spinning={apiLoading}>
                <div ref={pdfContainerRef}>
                  <h5 className="rfq-number new">
                    <span>Preview PO For Approval</span>
                  </h5>

                  {/* <Table
                    dataSource={data}
                    bordered
                    scroll={{
                      // x: 1000,
                      x: "auto",
                    }}
                    size="middle"
                    pagination={false}
                    columns={columns}
                    className="comparativecustomtbl"
                  /> */}

                  <Table
              // dataSource={comparativesRFQ}
              dataSource={data}
              bordered
              scroll={{
                // x: 1000,
                x: "auto",
              }}
              size="middle"
              pagination={false}
              columns={columns}
              className="comparativecustomtbl"
            />

                  <div className="TotalAMT">
                    <label>Total Amount: </label>
                    <div
                      className="citytotal"
                      style={{
                        width: "140px",
                        textAlign: "end",
                        fontWeight: "700",
                      }}
                    >
                      ₹{" "}
                      {poTotalAmount
                        ? poTotalAmount.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })
                        : 0}
                    </div>
                  </div>
                </div>

                {purchasePattern === "Approve and Issue Order" ? (
                  <>
                    <div className="btnwrp2" style={{ paddingTop: "16px" }}>
                      <ButtonField
                        type="primary"
                        className="SaveGradiantBtn w-auto"
                        label={t("Approve and Issue Order")}
                        loading={btnLoading}
                        onClick={handleDirectRelease}
                      />
                      <ButtonField
                        type="primary"
                        className="SaveGradiantBtn w-auto"
                        label={t("Reject")}
                        loading={btnLoading2}
                        onClick={handleReject}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "5px",
                      }}
                    >
                      <Input
                        placeholder="Write Remark Here If Any"
                        className="InputTotal"
                        style={{ marginTop: "11px", maxWidth: "600px" }}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="btnwrp2" style={{ paddingTop: "16px" }}>
                      <ButtonField
                        type="primary"
                        className="SaveGradiantBtn w-auto"
                        label={t("Approve and Prepare Draft Order")}
                        loading={btnLoading}
                        onClick={handleApproveDraftOrder}
                      />
                      <ButtonField
                        type="primary"
                        className="SaveGradiantBtn w-auto"
                        label={t("Reject")}
                        loading={btnLoading2}
                        onClick={handleReject}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "5px",
                      }}
                    >
                      <Input
                        placeholder="Write Remark Here If Any"
                        className="InputTotal"
                        style={{ marginTop: "11px", maxWidth: "600px" }}
                      />
                    </div>
                  </>
                )}
              </Spin>
            </div>
          </section>
        </Spin>
      </>
    );

    } else {


    return (
      <>
        <Spin spinning={apiLoading}>
          <div className="ListingTopBar">
            <div className="pagenamewrap">
              <div className="pagename">
                <h3>Approve Purchase Order</h3>

                <Breadcrumb className="Breadcrumb-Sec">
                  <Breadcrumb.Item>Approval</Breadcrumb.Item>
                  <Breadcrumb.Item>Approve Purchase Order</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <div className="rgq-num-wrap">
                <h5 className="rfq-number new">
                  RFQ Number : <span>{rfqNumber}</span>
                </h5>
              </div>
              <div className="btnwrp2" style={{visibility:'hidden'}}>
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="Excel"
                  label="PDF"
                  onClick={downloadAsPDF}
                  icon={<img src={ExelDownload} alt="Plus Square" />}
                />
              </div>
            </div>
          </div>

          <ShowComparatives />
          <section className="grid-sec mt-5">
            <div className="PR-body">
              <Spin spinning={apiLoading}>
                <div ref={pdfContainerRef}>
                  <h5 className="rfq-number new">
                    <span>Preview PO For Approval</span>
                  </h5>

                  <Table
                    dataSource={data}
                    bordered
                    scroll={{
                      // x: 1000,
                      x: "auto",
                    }}
                    size="middle"
                    pagination={false}
                    columns={columns}
                    className="comparativecustomtbl"
                  />

                  <div className="TotalAMT">
                    <label>Total Amount: </label>
                    <div
                      className="citytotal"
                      style={{
                        width: "140px",
                        textAlign: "end",
                        fontWeight: "700",
                      }}
                    >
                      ₹{" "}
                      {poTotalAmount
                        ? poTotalAmount.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })
                        : 0}
                    </div>
                  </div>
                </div>

                {purchasePattern === "Approve and Issue Order" ? (
                  <>
                    <div className="btnwrp2" style={{ paddingTop: "16px" }}>
                      <ButtonField
                        type="primary"
                        className="SaveGradiantBtn w-auto"
                        label={t("Approve and Issue Order")}
                        loading={btnLoading}
                        onClick={handleDirectRelease}
                      />
                      <ButtonField
                        type="primary"
                        className="SaveGradiantBtn w-auto"
                        label={t("Reject")}
                        loading={btnLoading2}
                        onClick={handleReject}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "5px",
                      }}
                    >
                      <Input
                        placeholder="Write Remark Here If Any"
                        className="InputTotal"
                        style={{ marginTop: "11px", maxWidth: "600px" }}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="btnwrp2" style={{ paddingTop: "16px" }}>
                      <ButtonField
                        type="primary"
                        className="SaveGradiantBtn w-auto"
                        label={t("Approve and Prepare Draft Order")}
                        loading={btnLoading}
                        onClick={handleApproveDraftOrder}
                      />
                      <ButtonField
                        type="primary"
                        className="SaveGradiantBtn w-auto"
                        label={t("Reject")}
                        loading={btnLoading2}
                        onClick={handleReject}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "5px",
                      }}
                    >
                      <Input
                        placeholder="Write Remark Here If Any"
                        className="InputTotal"
                        style={{ marginTop: "11px", maxWidth: "600px" }}
                      />
                    </div>
                  </>
                )}
              </Spin>
            </div>
          </section>
        </Spin>
      </>
    );
    }

  }
};

export default ApproveRFQ;
